import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Tabs as TabsWrapper } from 'react-tabs';

import { TabContainer } from "./styles";

const Tabs = (props) => {
  const { children } = props;

  return (
    <TabContainer>
      <TabsWrapper {...props}>
        {children}
      </TabsWrapper>
    </TabContainer>
  );
};

Tabs.propTypes = {
  children: PropTypes.node.isRequired,
};

export default memo(Tabs);
